import {
  Component,
  Input,
  ViewChild,
  OnInit,
  OnDestroy
} from '@angular/core';

import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

import { SkyVerticalTabComponent } from './../vertical-tabset/vertical-tab.component';
import { SkySectionedFormService } from './sectioned-form.service';


export class SkySectionedFormSectionComponent implements OnInit, OnDestroy {

  
  public heading: string;

  
  public itemCount: number;

  
  public active: boolean;

  public fieldRequired: boolean;
  public fieldInvalid: boolean;

  
  public tab: SkyVerticalTabComponent;

  private _ngUnsubscribe = new Subject();

  constructor(private sectionedFormService: SkySectionedFormService) {}

  public ngOnInit() {
    this.sectionedFormService.requiredChange
    .takeUntil(this._ngUnsubscribe)
    .subscribe((required: boolean) => this.fieldRequired = required);

  this.sectionedFormService.invalidChange
    .takeUntil(this._ngUnsubscribe)
    .subscribe((invalid: boolean) => this.fieldInvalid = invalid);
  }

  public ngOnDestroy() {
    this._ngUnsubscribe.next();
    this._ngUnsubscribe.complete();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-sectioned-form-section',
  template: `<sky-vertical-tab 
  [ngClass]="{
    'sky-tab-field-required': fieldRequired,
    'sky-tab-field-invalid': fieldInvalid
  }"
  [tabHeading]="heading" 
  [tabHeaderCount]="itemCount" 
  [active]="active"
  [showTabRightArrow]="true"
>
  <div #tabContent>
    <ng-content></ng-content>
  </div>
</sky-vertical-tab>`,
  providers: [SkySectionedFormService],
  styles: [`:host .sky-tab-field-required /deep/ .sky-vertical-tab-heading:after {
  content: "*";
  color: #ef4044;
  padding-left: 5px;
}

:host .sky-tab-field-invalid /deep/ .sky-vertical-tab-heading:after {
  content: "\\f071";
  font-family: FontAwesome;
  margin-right: 5px;
  color: #ef4044;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkySectionedFormService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'heading': [{ type: Input },],
'itemCount': [{ type: Input },],
'active': [{ type: Input },],
'tab': [{ type: ViewChild, args: [SkyVerticalTabComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
